import React from 'react';
import { CircleNotch } from 'phosphor-react';

/**
 * O giro. Estava copiado em 28 lugares e nenhum deles dizia nada para leitor de
 * tela — é isso que este componente centraliza, além de o tamanho/cor virarem
 * uma classe só.
 *
 * Use só onde o formato do que vem depois é imprevisível (envio, ação de botão).
 * Onde a tela já sabe o layout que vai chegar, o certo é `Skeleton`.
 *
 * Sob `prefers-reduced-motion` ele continua girando de propósito (ver index.css):
 * um spinner parado não diz "carregando", diz "travou".
 */
export default function Spinner({
  className = 'w-8 h-8 text-blush-400',
  label = 'Carregando',
}: {
  className?: string;
  label?: string;
}) {
  return (
    <span role="status" className="inline-flex">
      <CircleNotch className={`animate-spin ${className}`} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
